import { createContext } from 'react';

const NotFoundContext = createContext();

NotFoundContext.displayName = 'NotFoundContext';

export default NotFoundContext;
